export default {
  "accountPayable.th.name": "買掛金明細名",
  "accountPayable.th.requestDeadDate": "請求締日",
  "accountPayable.th.paymentDueDate": "支払予定日",
  "accountPayable.th.recordAmount": "計上金額",
  "accountPayable.th.amountPaid": "支払済額",
  "accountPayable.th.accountPayableBalance": "買掛金残高",

  "accountPayable.payment": "支払明細",
  "accountPayable.filmFeeFegistration": "フィルム料登録",
  "accountPayable.purchasePurchaseRegistration": "買取仕入登録",
  "accountPayable.consignmentPurchaseRegistration": "委託仕入登録",
  "accountPayable.otherPurchaseRegistration": "その他仕入登録",
  "accountPayable.oneTimePaymentRegistration": "一括支払登録",
  "accountPayable.paymentRegistration": "支払登録",
  "accountPayable.oneTimePayment": "一括支払",
  "accountPayable.otherPurchaseDialogTitle": "その他仕入（買掛金）",
  "accountPayable.trTotal": "全集計明細合計額",
  "accountPayable.accountPayableDetail": "買掛金明細名",
  "accountPayable.invoiceAmount": "請求書記載金額",
  "accountPayable.differenceFromTheAmountStatedOnTheInvoice": "請求書記載金額との差額",
  "accountPayable.otherPurchaseDetail": "その他仕入明細",
  "accountPayable.customerName": "取引先名",
  "accountPayable.detailedSummary": "詳細/摘要",
  "accountPayable.tableLastTrTotal": "全作成明細合計額",
  "accountPayable.accountPayableDetailBasicInformation": "買掛金明細基本情報",
  "accountPayable.paymentDetailBasicInformation": "支払明細基本情報",
  "accountPayable.targetPeriod": "対象期間",
  "accountPayable.income": "興行収入",
  "accountPayable.mobilization": "動員",
  "accountPayable.payMoney": "支払金額",
  "accountPayable.payMoneyTotal": "支払金額合計額",
  "accountPayable.adjustment": "仕入調整",
  "accountPayable.otherOffset": "その他相殺",
  "accountPayable.paymentName": "支払明細名",
  "accountPayable.paymentDate": "支払日",
  "accountPayable.accountPayment": "口座支払",
  "accountPayable.fromDepositDestination": "預金先から選択",
  "accountPayable.offset": "相殺",
  "accountPayable.fromAccountReceivableStatement": "売掛金明細から選択",
  "accountPayable.offsetPaymentStatement": "選択した売掛金明細に「相殺による入金明細」を作成する",
  "accountPayable.cash": "現金支払",
  "accountPayable.autoCash": "現金",
  "accountPayable.paymentCategory": "買掛金支払区分",
  "accountPayable.paymentTotal": "支払合計金額",
  "accountPayable.copyPayable": "支払金額に買掛金残高の金額をコピー",
  "accountPayable.paymentAmountDifference": "支払合計金額との差額",
  "accountPayable.threeTotal": "支払/調整/相殺金額",
  "accountPayable.productName": "商品名",
  "accountPayable.oneTimePaymentRegistration2": "一括支払（買掛金）登録",
  "accountPayable.accountReceivableOffset": "売掛金相殺",
  "accountPayable.requestName": "請求件名",
  "accountPayable.billingStatement": "請求明細",
  "accountPayable.client": "取引先",
  "accountPayable.accountsReceivableBalance": "売掛金残高",
  "accountPayable.offsetAmount": "相殺金額",
  "accountPayable.afterOffset": "相殺後売掛金残高",
  "accountPayable.otherOperatingIncomeOffset": "その他営業収入相殺",
  "accountPayable.otherPurchaseOffset": "その他仕入相殺",
  "accountPayable.otherOffsetTotal": "その他相殺合計",
  "accountPayable.itemName": "品目名",
  "accountPayable.arithmetic": "加減算",
  "accountPayable.plus": "加算",
  "accountPayable.reduce": "減算",
  "accountPayable.billMonth": "账单月",

  "accountPayable.placeholder.paymentName": "支払明細名を入力してください",
  "accountPayable.placeholder.accountPayableDetail": "買掛金明細名を入力してください",
  "accountPayable.placeholder.recordAmount": "計上金額を入力してください",
  "accountPayable.placeholder.choose": "選択してください",
  "accountPayable.placeholder.input": "入力してください",
  "accountPayable.placeholder.paymentTotal": "支払合計金額を入力してください",

  "accountPayable.type.TICKETING": "フィルム料",
  "accountPayable.type.BUY": "買取仕入",
  "accountPayable.type.ELSE_BUY": "その他仕入",
  "accountPayable.type.PROXY_BUY": "委託仕入",
};